import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "./features/auth/authSlice";
import { isSystemAdmin } from "./utilities/roleChecks";

const RequireSystemAdmin = () => {
  const user = useSelector(selectUser);
  const location = useLocation();

  // Check if user is authenticated and has completed onboarding
  if (!user?.completedOnboarding && user?.step < 4) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Check if user has System Admin role
  if (!isSystemAdmin(user)) {
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireSystemAdmin;
